/* unplugin-vue-components disabled */import script from "./PeiXun.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeiXun.vue?vue&type=script&setup=true&lang=ts"

import "./PeiXun.vue?vue&type=style&index=0&id=26a63ce8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a63ce8"]])

export default __exports__